import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { ControlLabel } from 'react-bootstrap';
import ModalForm from 'components/ModalForm';
import DropDownSemanticUI from './DropDownSemanticUI';
import styles from './styles.css';
import messages from './messages';

/* Error function for redux-form */
const validate = (values) => {
  const errors = {};
  if (!values.reason) {
    errors.reason = 'Please select an item in the list.';
  }
  return errors;
};

const RejectTransferForm = ({ handleSubmit, show, onHide }) => (
  <ModalForm
    onHide={onHide}
    show={show}
    handleSubmit={handleSubmit}
    title={<FormattedMessage {...messages.rejectTransfer} />}
  >
    <ControlLabel htmlFor="reason">
      <div className={styles.rejectReason}>
        <FormattedMessage {...messages.rejectReason} className={styles.rejectReasonInput} />
        <Field
          required
          name="reason"
          label="Select Reason"
          component={DropDownSemanticUI}
          className={classNames('form-control', styles.rejectReasonInput)}
        />
      </div>
    </ControlLabel>
    <ControlLabel htmlFor="comment" className={styles.commentLabel}>
      <FormattedMessage {...messages.comment} />
      <Field
        name="comment"
        component="textarea"
        className="form-control"
      />
    </ControlLabel>

  </ModalForm>
);


RejectTransferForm.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'RejectTransfer', validate, enableReinitialize: true })(RejectTransferForm);



// WEBPACK FOOTER //
// ./src/components/RejectTransferForm/index.js